/* eslint-disable react/no-unused-prop-types */
import { connect } from 'react-redux';
import { useMemo } from 'react';
import { Field } from 'react-final-form';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { getKnmDataCreated } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmOrder } from 'APIPackage/KnmModule/interfaces/IKnmOrder';

import { IInspectionResult } from '../../../APIPackage/CatalogsModule/interfaces/IInspectionResult';
import { IReasonRequirements } from '../../../APIPackage/DictionariesModule/interfaces/IReasonRequirements';
import { CHECKING_IN_REGESTRY, CHECKING_IN_REGESTRY_ORDER } from '../../../CorePackage/MainModule/constants/notices';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getDecisionDataCreatedAt } from '../../../DecisionPackage/MainModule/selectors/decisionSelectors';

interface IKnmNkoFieldProps {
  formRef: IKnmFormRef | undefined;
  id?: string;
  inspectionResult?: IInspectionResult;
  isDecision?: boolean;
  name?: string;
  value?: string;
  warningMessage?: string;
}

interface IKnmNkoFieldStoreProps {
  created: string | null | undefined;
  settings: IAdminSetting[] | undefined;
}

const KnmNkoFieldWithoutStore = ({
  formRef,
  id,
  inspectionResult,
  name,
  value,
  warningMessage,
  created,
  settings,
}: IKnmNkoFieldProps & IKnmNkoFieldStoreProps) => {
  const reasonRequirements: IReasonRequirements | undefined = formRef?.current.getFieldState(`reasonRequirements`)
    ?.value;
  const orderRequirements: IKnmOrder | undefined = formRef?.current.getFieldState(`orderRequirements`)?.value;

  const isShowMessage4154 = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_4_1_54_STARTS_FROM,
  );

  const isShowMessage5234153 = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_523_4_1_53_STARTS_FROM,
  );

  /**
   * Ошибка валидации НКО
   */
  const isErrorValidationNkoCompany = useMemo(() => {
    if (orderRequirements && isShowMessage5234153) {
      if (orderRequirements.flagInagency !== null) {
        if (
          value !== undefined &&
          ((orderRequirements.flagInagency === 'true' && value !== 'Да') ||
            (orderRequirements.flagInagency === 'false' && value !== 'Нет'))
        ) {
          return CHECKING_IN_REGESTRY_ORDER;
        }
      }
    } else if (reasonRequirements && reasonRequirements.inagency !== null && isShowMessage4154) {
      if (
        value &&
        ((reasonRequirements.inagency && value !== 'Да') || (reasonRequirements?.inagency === false && value !== 'Нет'))
      ) {
        return CHECKING_IN_REGESTRY;
      }
    }

    return '';
  }, [reasonRequirements, value]);

  return (
    <>
      <FieldBlock
        label="Наличие в реестре НКО, выполняющих функции иностранного агента"
        placementLabel="left"
        id={id}
        warning={warningMessage}
        error={inspectionResult ? undefined : isErrorValidationNkoCompany}
      >
        <TextInput className="shared-row-field" value={value} disabled inspectionResult={inspectionResult} />
      </FieldBlock>
      <Field name={`${name}` || ''}>{() => null}</Field>
    </>
  );
};

const mapStateToProps = (state: IRootState, { isDecision }: IKnmNkoFieldProps): IKnmNkoFieldStoreProps => ({
  created: isDecision === true ? getDecisionDataCreatedAt(state) : getKnmDataCreated(state),
  settings: getAdminFetchSettings(state),
});

export const KnmNkoField = connect(mapStateToProps)(KnmNkoFieldWithoutStore);
